module.exports = __webpack_public_path__ + "static/jeremiah-e718c2a0e4ea9600519860fab97121cf.jpeg";